<template>
  <div class="justify-center min-h-screen">
    <div class="flex flex-row min-h-screen">
      <!-- linear-gradient(180deg, #F4F4F4 0%, #7B8ECD 83.29%, #1E40AF 100%); -->
      <div
        class="
          bg-gradient-to-t
          from-primary
          via-pastel-blue
          to-white
          hidden
          lg:block lg:w-3/6
        "
      >
        <div class="flex h-full items-center">
          <LogoNoText :height="200" :width="200" class="mx-auto" />
        </div>
      </div>
      <div class="bg-white w-full lg:w-3/6 flex flex-col justify-center">
        <router-link
          :to="{ name: 'welcome' }"
          class="self-center inline-flex items-center py-3 text-sm font-medium text-indigo-600 hover:text-indigo-500"
        >
          <ArrowLeftIcon class="h-5 w-5 mr-2" aria-hidden="true" />
          Back to NIB Online home
        </router-link>
        <div class="mx-auto lg:hidden">
          <img
            src="/img/nib-logo-no-text.png"
            height="125"
            width="125"
            alt="NIB Logo"
          />
        </div>
        <h2 class="text-center font-bold">NIB Online Portal</h2>
        <div class="py-8 sm:rounded-lg">
          <RegistrationForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ArrowLeftIcon } from "@heroicons/vue/outline";
import DefaultLogo from "../components/layout/DefaultLogo.vue";
import RegistrationForm from "../components/auth/forms/RegistrationForm.vue";

export default defineComponent({
  name: "Registration page",
  components: {
    ArrowLeftIcon,
    DefaultLogo,
    RegistrationForm,
  },
  setup() {
    return {};
  },
});
</script>

<style lang="postcss" scoped>
.logo--area {
  width: 375px;
}
</style>
